import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

export default function (ComposedComponent, stateKeyName = 'auth', loginUrl = '/login') {
  class Authentication extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    static propTypes = {
      isAuthenticated: PropTypes.bool,
      currentUser: PropTypes.object,
      token: PropTypes.string,
    };

    static childContextTypes = {
      currentUser: PropTypes.object,
      token: PropTypes.string,
    }

    getChildContext () {
      const {
        currentUser,
        token,
      } = this.props
      return {
        currentUser,
        token,
      }
    }

    componentWillMount () {
      if (!this.props.isAuthenticated) {
        this.context.router.push(loginUrl)
      }
    }

    componentWillUpdate (nextProps) {
      if (!nextProps.isAuthenticated) {
        this.context.router.push(loginUrl)
      }
    }

    render () {
      if (this.props.isAuthenticated) {
        return <ComposedComponent {...this.props} />
      } else {
        return null
      }
    }
  }

  function mapStateToProps (state) {
    const {
      isAuthenticated,
      currentUser,
      token,
    } = state[stateKeyName]
    return {
      isAuthenticated,
      currentUser,
      token,
    }
  }

  return connect(mapStateToProps)(Authentication)
}



// WEBPACK FOOTER //
// ./src/components/Auth/RequireAuth.js